// Import styles - this will be separated in webpack by default
import './components/mobile-menu';
import './components/accordion';
import './components/archive-hero';
import './components/sliders';
import './components/information-bar';
import './components/single-product';
import './components/single-product-slider';
import './components/quantity';
import './components/checkout';
import './components/sticky-menu';
import './components/anchor-links';
import './components/my-account';
import './components/search';
import './components/usp';
import './components/input';
import './components/megamenu';
import './components/back-button';
import './components/woocommerce';
import './modules/newsletter';
import './modules/faq';
import './modules/maps';
import './pages/elastic-search';
import MiniCart from './components/mini-cart';
import overlayImages from './components/overlay-images';

// Instantiate the minicart react app.
// This only occurs if the default WC cart widget is used.
const disableMinicart = wp.hooks.applyFilters( 'qala_theme.filter.pre_disable_minicart', false );
if ( ! disableMinicart ) {
	const miniCart = document.querySelector( '.widget_shopping_cart' );
	if ( miniCart ) {
		new MiniCart();
	}
}

// Allow for child themes to disable the JS functionality of the overlay images.
if ( typeof qalaThemeScriptData !== 'undefined' ) {
	const disableOverlayImages = wp.hooks.applyFilters( 'qala_theme.filter.pre_disable_product_overlay_images', ! qalaThemeScriptData.showProductOverlayImages ?? false );
	if ( disableOverlayImages === false ) {
		new overlayImages();
	}
}
